import { Box, Checkbox, Grid, Typography, styled } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import SpeechToText from '../SpeechToText/SpeechToText';
import NotesTabs from './NotesTabs';
import { setSuggestion } from '../../redux/note/noteSlice';
import RecordingDisclaimerModal from '../SingleClient/RecordingDisclaimerModal/RecordingDisclaimerModal';
import { useAppSelector } from '../../redux/hooks';
import {
  ICreatePrivacySettingsPayload,
  createClientPrivacySettings,
} from '../../redux/client/clientSlice';
import createPermissionCheckers from '../../permissions-validation/createPermissionCheckers';
import { UserPermissionType } from '../../types/commonTypes';

const StyledCheckbox = styled(Checkbox)({
  color: '#6CA3AC',
  '&.Mui-checked': {
    color: '#6CA3AC',
  },
});

function NotesCard() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedClient, createPrivacySettingsLoading, openPrivacySettingsConcentModal } =
    useAppSelector((state) => state.client);
  const coachId = useAppSelector((state) => state.coach.coach.id);
  const coachAISettings = useAppSelector((state) => state.coach.coachAISettings);
  const [isAgreeBtn, setIsAgreeBtn] = useState(false);
  const [noteAssistEnabled, setNoteAssistEnabled] = useState(true);
  const [magicSuggestionsEnabled, setMagicSuggestionsEnabled] = useState(true);
  const permissionCheckers = createPermissionCheckers();
  const { checkPermissions } = permissionCheckers;

  const appendSuggestions = (suggestion: string) => {
    dispatch(setSuggestion(suggestion));
  };

  const handleAgreeConcent = () => {
    if (selectedClient) {
      const payload: ICreatePrivacySettingsPayload = {
        coachId,
        clientId: selectedClient?.id,
        noteAssistEnabled,
        magicSuggestionsEnabled,
      };
      setIsAgreeBtn(true);
      dispatch(createClientPrivacySettings(payload));
    }
  };

  const handleDisagreeConcent = () => {
    if (selectedClient) {
      const payload: ICreatePrivacySettingsPayload = {
        coachId,
        clientId: selectedClient?.id,
        noteAssistEnabled: false,
        magicSuggestionsEnabled: false,
      };
      setIsAgreeBtn(false);
      dispatch(createClientPrivacySettings(payload));
    }
  };

  return (
    <Box display="flex" gap="20px" height="75vh" width="100%" mt="20px">
      <Box width="70%" height="100%">
        <NotesTabs />
      </Box>
      {checkPermissions(UserPermissionType.NOTE_MODULE_USE_RECORDING) && (
        <Box width="30%" height="100%">
          <SpeechToText appendSuggestions={appendSuggestions} />
        </Box>
      )}
      {checkPermissions(UserPermissionType.CORE_MODULE_UPDATE_CLIENT_CONCENT) && (
        <RecordingDisclaimerModal
          handleOnClickLeft={() => handleDisagreeConcent()}
          handleOnClickRight={() => handleAgreeConcent()}
          content={
            <>
              <Typography variant="bodyRegular">
                {t('notes.recordingDisclaimer.createMessage.section1')}
              </Typography>
              <br />
              <br />
              <Typography variant="bodyRegular">
                {t('notes.recordingDisclaimer.createMessage.section2')}
              </Typography>
              <br />
              <br />
              <Grid container justifyContent="center">
                {coachAISettings.isMagicSuggestionEnabled && (
                  <Grid item xs={5} display="flex" alignItems="center">
                    <StyledCheckbox
                      checked={magicSuggestionsEnabled}
                      onChange={() => setMagicSuggestionsEnabled(!magicSuggestionsEnabled)}
                      inputProps={{ 'aria-label': 'controlled' }}
                      checkedIcon={
                        <Box component="img" src="/assets/icons/check-box-checked.svg" />
                      }
                    />
                    <Typography variant="bodyRegular">
                      {t('notes.recordingDisclaimer.createMessage.magicSuggestions')}
                    </Typography>
                  </Grid>
                )}
                {coachAISettings.isNoteTakingAIEnabled && (
                  <Grid item xs={5} display="flex" alignItems="center">
                    <StyledCheckbox
                      checked={noteAssistEnabled}
                      onChange={() => setNoteAssistEnabled(!noteAssistEnabled)}
                      inputProps={{ 'aria-label': 'controlled' }}
                      checkedIcon={
                        <Box component="img" src="/assets/icons/check-box-checked.svg" />
                      }
                    />
                    <Typography variant="bodyRegular">
                      {t('notes.recordingDisclaimer.createMessage.assistedNotes')}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </>
          }
          btnTextLeft={t('common.disagree')}
          btnTextRight={t('common.agree')}
          btnLeftLoading={createPrivacySettingsLoading && !isAgreeBtn}
          btnRightLoading={createPrivacySettingsLoading && isAgreeBtn}
          open={
            openPrivacySettingsConcentModal &&
            (coachAISettings.isMagicSuggestionEnabled || coachAISettings.isNoteTakingAIEnabled)
          }
        />
      )}
    </Box>
  );
}

export default NotesCard;
